<div class="linked-methods-autocomplete-container" [ngClass]="{ disabled: disabled }">
  <div class="autocomplete-wrapper">
    <div class="autocomplete-multi-select-wrapper">
      <div class="input-wrapper">
        <div class="options-wrapper">
          @for (selectedTag of control.value; track selectedTag; let tagIndex = $index) {
            <pdq-chip [label]="selectedTag" (onChange)="onRemoveTag(tagIndex)"> </pdq-chip>
          }
        </div>
        <pdq-input
          class="autocomplete-input"
          [control]="autocompleteControl"
          [withIcon]="!control.value?.length"
          icon="search"
          [background]="'transparent'"
          [placeholder]="control.value?.length ? ' ' : 'Start typing to search for shipping methods...'"
          [autofocus]="autofocus"
          [autocompleteMode]="true"
          [border]="false"
          [autoCompleteWidth]="419"
          [disabled]="disabled"
          [invalid]="control.invalid"
          [autocompleteRef]="pdqAutocomplete">
        </pdq-input>
      </div>
      <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" [mode]="'tags'">
        <ng-template pdqAutocompleteContent>
          @for (tag of options | filterStringResults: autocompleteControl.value; track tag) {
            <pdq-options (click)="onSelectTag(tag)" [value]="tag">
              <pdq-tag>{{ tag }} </pdq-tag>
            </pdq-options>
          }
        </ng-template>
      </pdq-autocomplete>
    </div>
  </div>
</div>
